import { useGetAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

const useGetAccount = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, isLoading } = useGetAccountQuery({ slug: accountSlug });
  const accountId = data?.data?.attributes?.["account-id"] as
    | number
    | undefined;
  return { accountId, account: data?.data, accountLoading: isLoading };
};

export default useGetAccount;
